<template>
  <input-select
    v-model="operadorFrontEnd"
    :search="pesquisaOperadorFrontEnd"
    :options="operadoresFrontEnd"
    placeholder="Todos"
    :disabled="disabled"
    :required="required"
  />
</template>

<script>
export default {
  data () {
    return {
      operadorFrontEnd: null,
      operadoresFrontEnd: []
    }
  },
  props: {
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    codigoParceiro: String
  },
  watch: {
    operadorFrontEnd (val) {
      if (val) {
        this.$emit('input', val)
      } else {
        this.$emit('input', null)
      }
      this.$emit('refresh')
    },
    codigoParceiro (val, oldVal) {
      this.reload()
    }
  },
  methods: {
    carregaOperadoresFrontEnd (filtroOperador, codigoOperador) {
      const th = this
      this.operadoresFrontEnd = []

      let dto = {
        parameters: [
          { name: 'codigoParceiro', value: this.codigoParceiro },
          { name: 'perfilOperador', values: [1] },
          { name: 'filtroOperador', value: filtroOperador }
        ]
      }

      th.$api.OperadorFrontEnd.ComboOperadoresFrontEnd(dto).then(function (
        data
      ) {
        if (!data.length || data.length === 0) {
          th.$api.UI.ShowError(
            'Erro',
            'Não foram encontradas operadores com os parâmetros informados.'
          )
        } else {
          data.forEach(function (item) {
            th.operadoresFrontEnd.push({
              value: item.codigo,
              nome: item.nome,
              email: item.email,
              text: item.nome + ' - ' + item.email
            })
          })

          if (codigoOperador) {
            th.operadorFrontEnd = th.operadoresFrontEnd.find(
              c => c.value === codigoOperador
            )
          }
        }
      })
    },
    reload () {
      this.operadorFrontEnd = null
      this.carregaOperadoresFrontEnd()
    }
  },
  beforeMount () {
    this.carregaOperadoresFrontEnd()
  },
  created () {
    // eslint-disable-next-line no-undef
    this.pesquisaOperadorFrontEnd = _.debounce(
      this.carregaOperadoresFrontEnd,
      300
    )
  }
}
</script>

<style>
</style>
